import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Utils from "../utils/Utils";

const { serverURL } = Utils;

const initialState = {
    status: "",
    conversations: [],
    unreadCount: 0,
};


export const conversation = createAsyncThunk(
  "chat/conversation",
  async (userId) => {
    const response = await fetch(`${serverURL}/chat/conversations/${userId}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });
    if (!response.ok) throw new Error(await response.text());
    const profile = await response.json();
    return profile;
  }
);

export const reportConversation = createAsyncThunk(
  "conversations/reportConversation",
  async (report) => {
    const response = await fetch(`${serverURL}/chat/report`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(report),
      credentials: "include",
    });
    console.log("reportConversation response", response);
    if (response.status === 400) {
      const errorMessage = await response.text();
      throw new Error(errorMessage);
    }
    if (!response.ok) throw new Error(await response.text());
    const reportDetails = await response.json();
    return reportDetails;
  }
);

export const fetchUnreadCount = createAsyncThunk(
  "conversations/fetchUnreadCount",
  async (userId) => {
    const response = await fetch(`${serverURL}/chat/unread-count/${userId}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });
    if (!response.ok) throw new Error(await response.text());
    const data = await response.json();
    return data.unreadCount;
  }
);

export const conversationSlice = createSlice({
  name: "conversations",
  initialState,
  reducers: {
    setConversations: (state, action) => {
      state.conversations = action.payload.conversations;
      if (Array.isArray(action.payload.conversations)) {
        state.unreadCount = action.payload.conversations.filter(
          (conversation) => (conversation?.unreadCount || 0) > 0
        ).length;
      }
    },
    setUnreadCount: (state, action) => {
      state.unreadCount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(conversation.fulfilled, (state, action) => {
      state.conversations = action.payload.data;
      if (Array.isArray(action.payload.data)) {
        state.unreadCount = action.payload.data.filter(
          (conversation) => (conversation?.unreadCount || 0) > 0
        ).length;
      }
      state.status = "success";
    });
    builder.addCase(conversation.rejected, (state, action) => {
      state.status = "failed";
    });
    builder.addCase(fetchUnreadCount.fulfilled, (state, action) => {
      state.unreadCount = action.payload;
    });
  },
});

export default conversationSlice.reducer;
export const { setConversations, setUnreadCount } = conversationSlice.actions;
